export function parseDate(input: string | Date | number): Date | null {
    const dateObj = new Date(input);
    return isNaN(dateObj.getTime()) ? null : dateObj;
}
